import { ExchangeRatePolicy } from "./ExchangeRatePolicy";

export const exchangeRatePolicy = new ExchangeRatePolicy()